export type GeolocationRelocateOptions = {
  force?: boolean;
};

type RelocateHandler = (options?: GeolocationRelocateOptions) => void;

let relocateHandler: RelocateHandler | null = null;

export const registerGeolocationRelocate = (handler: RelocateHandler) => {
  relocateHandler = handler;
};

export const unregisterGeolocationRelocate = () => {
  relocateHandler = null;
};

/** Invoked from geo callbacks to re-run locate without a user soft-reload. */
export const requestGeolocationRelocate = (
  options?: GeolocationRelocateOptions,
) => {
  relocateHandler?.(options);
};
